"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _constants = require("../constants");
var styleOverrides = {
    root: {
        // Scrollbar
        '@media (hover: hover) and (pointer: fine)': {
            '&, & *': {
                msOverflowStyle: '-ms-autohiding-scrollbar',
                scrollbarWidth: 'thin',
                scrollbarColor: "".concat(_constants.colors.oriGrey[300], " transparent")
            },
            // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
            '::-webkit-scrollbar, & *::-webkit-scrollbar': {
                width: '15px',
                height: '15px'
            },
            // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
            '::-webkit-scrollbar-track, & *::-webkit-scrollbar-track': {
                background: 'transparent'
            },
            // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
            '::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
                background: _constants.colors.oriGrey[300],
                borderRadius: '13px',
                border: '5px solid transparent',
                backgroundClip: 'content-box'
            }
        }
    }
};
var _default = exports.default = {
    styleOverrides: styleOverrides
}; //# sourceMappingURL=MuiScopedCssBaseline.js.map
